import {BaseService} from './baseService.js';

/**
 * Application Module admin API
 */
export class ApplicationModuleService extends BaseService {

	constructor() {
		super();
	}

	async getModules(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/application-modules' + params);
		return data;
	}

	async getModuleDetail(code) {
		var data = await this.makeGETRequest('/api/resource/application-modules/' + encodeURIComponent(code));
		return data;
	}

	async saveModule(detail, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/application-modules/' + encodeURIComponent(detail.module.code), detail);
		} else {
			saved = await this.makePOSTRequest('/api/resource/application-modules', detail);
		}
		return saved;
	}

	async activateModule(code) {
		return await this.makePUTRequest('/api/resource/application-modules/' + encodeURIComponent(code) + '/activate');
	}

	async inactivateModule(code) {
		return await this.makePUTRequest('/api/resource/application-modules/' + encodeURIComponent(code) + '/inactivate');
	}

	async getAvailabilityChecks() {
		return await this.makeGETRequest('/api/resource/application-modules/availability-checks');
	}

}
